export default "__VITE_ASSET__GobOrJzH__"